import { defineMessages } from 'react-intl';

type MessageKeys = 'fileUploadButtonLabel' | 'fileUploadButtonMaxFilesLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	fileUploadButtonLabel: {
		id: 'rovo-chat.file-upload-button.label',
		defaultMessage: 'Upload file',
		description: 'Label for the file upload button in the chat input',
	},
	fileUploadButtonMaxFilesLabel: {
		id: 'rovo-chat.file-upload-button.max-files-label',
		defaultMessage: 'Limit of {maxFiles, plural, one {# file} other {# files}} reached',
		description: 'Label for the file upload button in the chat input when max files is set',
	},
});

export default message;
